import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vShow as _vShow, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-container"
}
const _hoisted_2 = {
  class: "modal-title",
  ref: "modalTitle"
}
const _hoisted_3 = { class: "title-block" }
const _hoisted_4 = {
  key: 0,
  class: "title"
}
const _hoisted_5 = { class: "modal-content" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { for: "count-before" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "buttons" }

import { inject, onBeforeUnmount, onMounted, reactive, ref } from "vue";
  import { trans } from "@/utils/trans";
  import { useToast } from "primevue/usetoast";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import apiClient from "@/services/api";
  import { ILiveUserAlertSetting } from "@/models";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LiveLotAlertPopup',
  setup(__props) {

  const emitter = inject("emitter");
  const toast = useToast();
  const auctionStore = useAuctionStore();

  const state = reactive({
    isVisible: false,
    title: null,
    lotId: null as number,
    settings: null as ILiveUserAlertSetting,
    countBeforeOptions: [...new Array(100).keys()].map((item, i) => i + 1)
  });

  const modalBlock = ref<HTMLDivElement>();

  onMounted(() => {
    document.addEventListener("keydown", closeByEscapeKey);
  });

  onBeforeUnmount(() => {
    document.removeEventListener("keydown", closeByEscapeKey);
  });

  const open = () => {
    state.isVisible = true;
    document.body.classList.add("overflow-hidden");
    document.addEventListener("keydown", closeByEscapeKey);
  };

  const close = () => {
    state.isVisible = false;
    // state.customScroll.style.height = "";
    document.body.classList.remove("overflow-hidden");
    document.removeEventListener("keydown", closeByEscapeKey);
  };

  const closeByEscapeKey = (event) => {
    if (event.keyCode === 27) {
      close();
    }
  };

  const save = () => {
    if (Notification.permission !== "granted") {
      Notification.requestPermission();
    }

    apiClient
      .post(`/live/lots/${state.lotId}/alert`, state.settings)
      .then((response) => {
        if (response.data.status) {
          auctionStore.$patch((storeState) => {
            let lotIndex = storeState.lots.findIndex((lot) => lot.id === response.data.lot_id);
            if (lotIndex >= 0) {
              storeState.lots[lotIndex].alert_enabled = true;
            }
            lotIndex = storeState.catalog?.searchLots?.findIndex((lot) => lot.id === response.data.lot_id);
            if (lotIndex >= 0) {
              storeState.catalog.searchLots[lotIndex].alert_enabled = true;
            }
          });
        }

        toast.add({
          severity: response.data.status ? "success" : "error",
          summary: trans("live.toast." + (response.data.status ? "success" : "error")),
          detail: response.data.message || trans("live.toast.unknown_error"),
          life: 6000
        });

        response.data.status && close();
      })
      .catch((error) => {
        toast.add({
          severity: "error",
          summary: trans("live.toast.error"),
          detail: error?.response?.data.message || trans("live.toast.unknown_error"),
          life: 6000
        });
      });
  };

  emitter?.on(
    "on:live-lot-alerts:modal-show",
    (data: { title: string; lotId: number; settings: ILiveUserAlertSetting }) => {
      if (data.lotId) {
        state.title = data.title;
        state.lotId = data.lotId;
        state.settings = data.settings || { count_before: 1 };
        open();
      } else {
        close();
        toast.add({
          severity: "error",
          summary: trans("live.toast.error"),
          detail: trans("live.toast.not_found.lot"),
          life: 6000
        });
      }
    }
  );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (state.isVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "modal live-lot-alert-popup",
            ref_key: "modalBlock",
            ref: modalBlock
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (state.title)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(state.title), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: "modal__close",
                onClick: close
              })
            ], 512),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(trans)("live.modals.live_lot_alert.labels.count_before")), 1),
                _withDirectives(_createElementVNode("select", {
                  id: "count-before",
                  class: "form-select-field",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.settings.count_before) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.countBeforeOptions, (count) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: count,
                      key: count
                    }, _toDisplayString(count), 9, _hoisted_8))
                  }), 128))
                ], 512), [
                  [_vModelSelect, state.settings.count_before]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  class: "btn btn-blue",
                  onClick: save
                }, _toDisplayString(_unref(trans)("live.modals.live_lot_alert.save_btn")), 1),
                _createElementVNode("button", {
                  class: "btn btn-blue-outline",
                  onClick: close
                }, _toDisplayString(_unref(trans)("live.modals.live_lot_alert.cancel_btn")), 1)
              ])
            ])
          ], 512)
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", {
      class: "modal-overlay background-fill",
      onClick: close
    }, null, 512), [
      [_vShow, state.isVisible]
    ])
  ]))
}
}

})